import React, { useState } from 'react';
import { PlusIcon } from '@heroicons/react/20/solid';
import { useAuth } from '../../portal/context/auth-context';
import AddNewShippingMethod from './AddNewShippingMethod';
import Tooltip from '../../components/Tooltip';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
export default function ShippingMethod({ setShowPO, showPO, handleSubmitOrder }) {
    const { currentUser } = useAuth();

    const getSelectedShipping = () => {
        const selectedShipping = currentUser.shipMethods.find((item) => item.selected === true);
        return selectedShipping || null;
    };

    const [shippingInfoState, setShippingInfoState] = useState(currentUser.shipMethods);
    const [newShipping, setNewShipping] = useState(false);
    const [selectedShipping, setSelectedShipping] = useState(getSelectedShipping());
    const [open, setOpen] = useState(false);
    const [errorAddingAddress, setErrorAddingAddress] = useState(false);
    const [noShippingSelected, setNoShippingSelected] = useState(false);

    const handleSubmit = () => {
        shippingInfoState.map((item) => {
            if (item.selected) {
                setSelectedShipping(item);
                currentUser.selectedShipMethod = item;
            }
        });
        handleSubmitOrder();
    };

    const handleNewAddress = (newAddress) => {
        newAddress.selected = true;
        setSelectedShipping(newAddress);
        setShippingInfoState((prevState) => {
            return [...prevState, newAddress];
        });
    };
    return (
        <>
            {open && (
                <AddNewShippingMethod
                    open={open}
                    setOpen={setOpen}
                    handleNewAddress={handleNewAddress}
                    setErrorAddingAddress={setErrorAddingAddress}
                    errorAddingAddress={errorAddingAddress}
                />
            )}
            <div className='px-4 py-5 mt-6 border-2 border-gray-200 sm:p-6'>
                <div className='mt-4'>
                    <h3 className='text-xl font-medium leading-6 text-gray-900'>Shipping Method</h3>
                    {!showPO && (
                        <div className='mt-2'>
                            <p className='text-sm text-gray-500'>Please select your ship method from the list below.</p>
                        </div>
                    )}
                </div>
                <div className='mt-6'>
                    <div className='flex flex-row justify-between'>
                        <div className='-my-2 sm:-mx-6 lg:-mx-8'>
                            <div className='flex flex-col flex-wrap justify-start py-2 pl-6 w-full md:flex-row'>
                                {!showPO &&
                                    shippingInfoState.map((info, idx) => (
                                        <div
                                            key={idx}
                                            onClick={() => {
                                                setShippingInfoState(
                                                    shippingInfoState.map((item) => {
                                                        if (item.shipMethodId === info.shipMethodId) {
                                                            return { ...item, selected: true };
                                                        } else {
                                                            return { ...item, selected: false };
                                                        }
                                                    })
                                                );
                                                setSelectedShipping(info);
                                                setNewShipping(false);
                                            }}
                                            className={classNames(
                                                info.selected
                                                    ? 'bg-gray-50 border-2 border-blue-primary '
                                                    : 'bg-white text-gray-900',
                                                'shadow-md border cursor-pointer sm:rounded-md w-52 hover:-translate-y-1 transform transition-all duration-300 mx-1 my-2 p-3 flex flex-col justify-around'
                                            )}
                                        >
                                            <div className='py-5 sm:px-2'>
                                                <h3 className='font-medium leading-6 text-gray-900 text-md'>
                                                    {info.shipMethodDescription}
                                                </h3>
                                                <p className='mt-1 max-w-2xl text-sm text-gray-600'>{info.shipCarrier}</p>
                                                <p className='mt-1 max-w-2xl text-sm text-gray-600'>{info.shipMethodName}</p>
                                                <p className='mt-1 max-w-2xl text-sm text-gray-600'>
                                                    Account: <span className='font-semibold'> {info.accountNumber}</span>
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                {!showPO && (
                                    <div
                                        onClick={() => {
                                            setOpen(true);
                                        }}
                                        className='flex flex-col justify-around p-3 mx-1 my-2 w-52 text-gray-900 bg-white border shadow-md transition-all duration-300 transform cursor-pointer sm:rounded-md hover:-translate-y-1'
                                    >
                                        <div className='flex flex-col justify-center items-center px-4 py-5 sm:px-6'>
                                            <h3 className='text-lg font-medium leading-6 text-gray-900'>Add new</h3>
                                            <PlusIcon className='w-20 h-20 text-blue-primary' />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {!showPO ? (
                    <div
                        onMouseEnter={() => {
                            if (selectedShipping === null || selectedShipping === undefined) {
                                setNoShippingSelected(true);
                            } else {
                                setNoShippingSelected(false);
                            }
                        }}
                        onMouseLeave={() => {
                            setNoShippingSelected(false);
                        }}
                        className='inline-block'
                    >
                        <button
                            onClick={handleSubmit}
                            disabled={selectedShipping === null || selectedShipping === undefined}
                            type='button'
                            className='inline-flex justify-center px-4 py-2 mt-6 w-52 font-medium text-white rounded-md border border-transparent shadow-sm cursor-pointer text-md bg-blue-primary hover:bg-blue-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary'
                        >
                            <p>Review Order</p>
                        </button>
                    </div>
                ) : (
                    <button
                        onClick={() => {
                            setShowPO(!showPO);
                        }}
                        type='button'
                        className='inline-flex justify-center px-4 py-2 font-medium bg-white rounded-md border shadow-sm border-blue-primary text-md text-blue-primary hover:bg-blue-primary hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary'
                    >
                        <p>Next</p>
                    </button>
                )}
                {noShippingSelected && <Tooltip text='Please select shipping method to proceed' />}
            </div>
        </>
    );
}
